module.exports = __webpack_public_path__ + "img/NL895.b514e526.svg";